export default {
  borderRadius: 'medium',
  borderColor: 'brandOne80',
};
